import get from 'lodash/get';
import moment from 'moment';
import {roundTo} from 'round-to';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { formatAppointmentAddress } from './appointments';
import { capitalize } from "./stringUtils";
import { isDirectBilling } from './cases';


export const getSessionStatus = session => {
  if (session.is_completed) return 'Completed';
  if (session.is_canceled) return 'Canceled';
  const now = moment().valueOf();
  const sessionTime = moment(session.date).valueOf();
  if (sessionTime > now) return 'Upcoming';
  return 'Incomplete';
};

export const calculateSessionTotal = session => {
  if (isDirectBilling(session?.case)) {
    return roundTo((
      parseFloat(session?.case?.payer_plan?.copay)
      * (1 - .01 * roundTo(session.discount || 0, 8))
    ), 2);
  }
  return roundTo(
    ( parseInt(session.rate, 10)
      * (
        (
          session.duration
          ? parseInt(session.duration, 10)
          : parseInt(session.duration, 10)
        ) / 60
      )
      * (1 - .01 * roundTo(session.discount || 0, 8))
    ), 2
  );
}

export const calculateSessionRate = session => {
  let rate = session?.rate;
  if (!rate && session?.case?.provider_hourly_rate) rate = session?.case?.provider_hourly_rate;
  if (!rate && session?.provider?.rate) rate = session?.provider?.rate;
  if (rate) return roundTo(rate, 2);
  return '';
};

export const getSessionCategory = session => {
  const rawStr = get(session, 'category', '') || '';
  if (!rawStr) return rawStr;
  return capitalize(rawStr);
};

export const formatSessionDate = (session, format) => (
  moment(session.date).format(format ?? 'MM/DD/YYYY')
);

export const formatSessionTime = session => (
  moment(session.date).format('h:mm a')
);

export const formatSessionLocation = (session, config = {returnLink: false, returnLinkText: false}) => {
  if (session.location === 'Other Mobile') {
    return (
      <span className='text-error'>
        Other Mobile
      </span>
    );
  };
  if (session.platform_version === '1.0') {
    const locationStr = session.location;
    if (!config.returnLinkText && !config.returnLink) return locationStr;
    const url = locationStr ? `https://www.google.com/maps/search/?api=1&query=${encodeURI(locationStr)}` : null;
    return (
      <a href={url} target='_blank' rel='noreferrer'>
        {locationStr}
      </a>
    );
  }
  const address = (
    session.appointment_scheduled
    ? formatAppointmentAddress(session.appointment_scheduled)
    : null
  );
  const url = address ? `https://www.google.com/maps/search/?api=1&query=${encodeURI(address)}` : null;

  if (config.returnLink && url) {
    return (
      <Button href={url} target='_blank' component='a' variant='text'>
        <Typography variant='large'>
          {address}
        </Typography>
      </Button>
    );
  }
  if (config.returnLinkText && url) {
    return <a href={url} target='_blank' rel="noreferrer">{address}</a>;
  }
  if (address) return address;
  const location = get(session, 'location');
  switch (location) {
    case 'PARTNER':
      return 'Partner Facility';
    // case 'PROVIDER_HOME':
    // return 'Provider\'s Home';
    // case 'GYM':
    // return 'Patient\'s Gym';
    case 'HOME':
      return 'Patient\'s Home';
    // case 'WORK':
    // return 'Patient\s Work';
    case 'VIRTUAL':
      return 'Virtual';
    case 'OTHER_MOBILE':
      return 'Other Mobile';
    default:
      return '';
  }
};

export const formatSessionVirtualLink = (session, config = { returnLink: false, returnLinkText: false }) => {
  if (session?.appointment_scheduled?.session_type?.location_type !== 'VIRTUAL') return null;
  const url = (
    session?.appointment_scheduled?.session_meeting_url
    || session?.appointment_scheduled?.session_type?.session_meeting_url
    || ''
  );
  if (!url) return null;
  if (config.returnLinkText) {
    return <a href={url} target='_blank' rel="noreferrer">Join Virtual Session</a>
  }

  if (!config.returnLink) return url;
  return (
    <Button
      variant='text'
      href={url}
      target='_blank'
      component='a'
    >
      Join Virtual Session
    </Button>
  );
};

export const getSessionLink = sessionId => (
  `/providers/sessions/view/${sessionId}`
);
